import { useRef, useEffect, useState } from "react"; 
//-------------------------------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import Esign from "src/components/common/esign";
import Sketch from "src/components/common/sketch";
import { useMyStore } from "src/components/main/mainStore";
import { myAxios, MyFormData, MyDate } from "src/components/common/functions";
export const surfaces = [
    "Asphalt", 
    "Concrete", 
    "Grass/Dirt"
]
export const coreDrills = [
    "Core Drill Asphalt", 
    "Core Drill Concrete", 
    "No Core Drill"
]
export const soilTypes = [
    "Sand", 
    "Dirt", 
    "Rock", 
    "Compact Base Rock", 
    "Clay",
    "Pea Gravel", 
    "Mud", 
    "Slurry", 
    "Concrete"
];
export const utilityTypes = [
    "Gas", 
    "Electric", 
    "Fiber", 
    "Cable TV", 
    "Communication", 
    "Telephone", 
    "SPRINT", 
    "VERIZON", 
    "AT&T", 
    "CATV", 
    "Water", 
    "Sewer", 
    "Irrigation", 
    "Portable Water", 
    "Concrete", 
    "Storm Drain", 
    "Recycled Water", 
    "Nitrogen Gas", 
    "Kinder Morgan Line", 
    "Phillips 66", 
    "Chevron", 
    "Crimson", 
    "Joint Trench", 
    "Shell", 
    "CPN Pipeline", 
    "Martinez Pipeline", 
    "Level 3",
	"FAA",
	"(Greyson)",
    "Unknown"
];
//-------------------------------------------------------------------------------------------------------------------
export default function PotholingForm({
    closeIt, 
    setWorkLogs, 
    adminLink, 
    potholingFormObj, 

    // workLog
    workLogHashKey, 
    workInstructionHashKey, 
    projectName, 
    userName, 
    contactName
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    // workLog: workLogHashKey, potholingForm, workInstructionHashKey, projectName
    const [showLoading, setShowLoading] = useState(true);
    //-----------------------------------------------------------
    const [sketches, setSketches] = useState([]);
    const [picData, setPicData] = useState([]);
    const [picData2, setPicData2] = useState([]);
    const [showSketch, setShowSketch] = useState(false);
    const [curPotholingForm, setCurPotholingForm] = useState({});
    //-----------------------------------------------------------
    const [pt, setPt] = useState("");
    const [holeSize, setHoleSize] = useState("");
    const [pipeSize, setPipeSize] = useState("");
    const [depth, setDepth] = useState("");
    //-------------------------------------------------------------------------------------------------------------------
    const canvasRef = useRef(null);
    const PT = pt === ""? 30 : pt / 1; 
    const Depth = depth === ""? 100 : depth / 1;
    const PipeSize = pipeSize === ""? 50 : pipeSize / 1;
    const HoleSize = holeSize === ""? 60 : holeSize / 1;
    const originX = 220;
    const originY = 120;
    const canvasHeight = originY + Depth + PipeSize + 12.5;
    const inputWidth = 70;
    const inputHeight = 30;
    const inputInitLeft = -1 * inputWidth / 2;
    const canvasFontSize = 15;
    const ptWidth = 100;
    const arrow1OffsetX = -25; 
    const arrow2OffsetY = -25;
    const arrow3OffsetX = -25;
    const arrow4OffsetX = 25;
    const arrowlength = 25;
    const annotationBarLength = 25;
    const inputOffsetX = -12.5;
    const inputOffsetY = -12.5;
    const input1CurX = originX - inputWidth / 2 - annotationBarLength/2 + arrow1OffsetX + inputOffsetX;
    const input1CurY = originY + PT / 2;
    const input1Top = inputOffsetY + input1CurY;
    const input1Left = inputInitLeft + input1CurX;
    const input2CurX = originX + ptWidth + HoleSize / 2;
    const input2CurY = originY + arrow2OffsetY - annotationBarLength / 2 - inputHeight / 2 + inputOffsetY;
    const input2Top = inputOffsetY + input2CurY;
    const input2Left = inputInitLeft + input2CurX;
    const input3CurX = originX + ptWidth + arrow3OffsetX - annotationBarLength / 2 - inputWidth / 2 + inputOffsetY;
    const input3CurY = originY + Depth;
    const input3Top = inputOffsetY + input3CurY + PipeSize / 2;
    const input3Left = inputInitLeft + input3CurX;
    const text4Length = 65;
    const text4X = originX + 2 * ptWidth + HoleSize + arrow4OffsetX + annotationBarLength /2;
    const text4Y = originY + Depth / 2 + canvasFontSize / 2;
    const input4CurX = text4X + text4Length + inputWidth / 2;
    const input4CurY = originY + Depth / 2;
    const input4Top = inputOffsetY + input4CurY;
    const input4Left = inputInitLeft + input4CurX - inputOffsetX;
    const canvasWidth = input4Left + 35 + (curPotholingForm.topDepth?.toString().length ?? 0) * 8.5;
    const squeeze = 5;
    const text1Spacing = inputHeight - 2 * squeeze;
    const text1offsetY = canvasFontSize / 2 + squeeze;
    const text1Length = 70;
    const text1X = input1Left - text1Length + inputOffsetX;
    const text1Y = originY + PT / 2 - inputHeight / 2 + text1offsetY;
    const text2Length = 85;
    const text2X = input2CurX - text2Length / 2;
    const text2Y = input2CurY - inputHeight / 2 + inputOffsetY;
    const text3Length = 60;
    const text3X = input3Left - text3Length + inputOffsetX;
    const text3Y = originY + Depth + canvasFontSize / 2 + PipeSize / 2;
    //-------------------------------------------------------------------------------------------------------------------
    const canvas_line = (context, fromx, fromy, tox, toy) => {
        context.moveTo(fromx, fromy);
        context.lineTo(tox, toy);
    }
    const canvas_arrow = (context, fromx, fromy, tox, toy, dual) => {
        const headlen = 10; // length of head in pixels
        const dx = tox - fromx;
        const dy = toy - fromy;
        const angle = Math.atan2(dy, dx);
        context.moveTo(fromx, fromy);
        context.lineTo(tox, toy);
        //context.moveTo(tox, toy);
        context.lineTo(tox - headlen * Math.cos(angle - Math.PI / 6), toy - headlen * Math.sin(angle - Math.PI / 6));
        context.moveTo(tox, toy);
        context.lineTo(tox - headlen * Math.cos(angle + Math.PI / 6), toy - headlen * Math.sin(angle + Math.PI / 6));
        if(dual){
            context.moveTo(fromx, fromy);
            context.lineTo(fromx + headlen * Math.cos(angle - Math.PI / 6), fromy + headlen * Math.sin(angle - Math.PI / 6));
            context.moveTo(fromx, fromy);
            context.lineTo(fromx + headlen * Math.cos(angle + Math.PI / 6), fromy + headlen * Math.sin(angle + Math.PI / 6));
        }
    }
    const handlePotholingFormSave = async e => {
        if(potholingFormObj.hashKey === undefined || potholingFormObj.hashKey === "undefined"){
            window.alert("Error. Please send screenshot to IT.");
            return;
        }
        if(showSketch){
            window.alert("You have an unsaved sketch.");
            return;
        }
        const formData = new MyFormData(e);
        formData.append("email", user.email);
        formData.append("password", user.password);
        formData.append("sketches", JSON.stringify(sketches.map(sketch => ({
            ...sketch, sketchBgImg: 
            // sketch.sketchBgImg?[
            //     sketch.sketchBgImg[0].src, 
            //     sketch.sketchBgImg[1],
            //     sketch.sketchBgImg[2],
            //     sketch.sketchBgImg[3],
            //     sketch.sketchBgImg[4]
            // ]:
            ""
        }))));
        formData.append("sign", JSON.stringify(picData));
        formData.append("sign2", JSON.stringify(picData2));
        formData.append("action", "Save");
        formData.append("potholingFormHashKey", potholingFormObj.hashKey);
        //---------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("workLogs/phForm.php", formData);
        setShowLoader(false);
        if(!res) return;
        //---------------------------------------------------
        setWorkLogs(workLogs => workLogs.map(thisWorkLog => ({
            ...thisWorkLog, 
            potholingForm: 
            thisWorkLog.workLogHashKey === workLogHashKey?
            JSON.stringify(res.data):thisWorkLog.potholingForm
        })));
        closeIt();
    }
    const handlePotholingFormSubmit = async e => {
        e.preventDefault();
        if(potholingFormObj.hashKey === undefined || potholingFormObj.hashKey === "undefined"){
            window.alert("Error. Please send screenshot to IT.");
            return;
        }
        if(showSketch){
            window.alert("You have an unsaved sketch.");
            return;
        }
         if(!picData.length){
            window.alert("Please Sign!");
            return;
        }
        const formToSubmit = e.currentTarget;
        const formData = new MyFormData(formToSubmit);
        formData.append("workInstructionHashKey", workInstructionHashKey);
        formData.append("sketches", JSON.stringify(sketches.map(e => ({
            ...e, sketchBgImg: ""
        }))));
        formData.append("sign", JSON.stringify(picData));
        formData.append("sign2", JSON.stringify(picData2));
        formData.append("projectName", projectName);
        
        formData.append("form", "potholingForm");
        formData.append("signUrl", document.getElementById("esigna").toDataURL());
        formData.append("sign2Url", document.getElementById("esignb").toDataURL());
        if(curPotholingForm.cancel === "No"){
            formData.append("graph", canvasRef.current.toDataURL());
        }
        //---------------------------------------------------
        formData.append("action", "Submit");
        formData.append("potholingFormHashKey", potholingFormObj.hashKey);
        //---------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("workLogs/phForm.php", formData);
        setShowLoader(false);
        if(!res) return;
        //---------------------------------------------------
        setWorkLogs(workLogs => workLogs.map(w => ({
            ...w, workLogFiles:(
                w.workLogHashKey === workLogHashKey?
                res.data[0]:
                w.workLogFiles
            ), potholingForm:(
                w.workLogHashKey === workLogHashKey?
                res.data[1]:
                w.potholingForm
            ), potholingFormSubmitTime: res.data[2]
        })));
        closeIt();
    }
    //-------------------------------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async() => {
            if(potholingFormObj.hashKey === undefined || potholingFormObj.hashKey === "undefined"){
                window.alert("Error. Please send screenshot to IT.");
                return;
            }
            const formData = new MyFormData();
            formData.append("potholingFormHashKey", potholingFormObj.hashKey);
            formData.append("action", "Read");
            //---------------------------------------------------
            setShowLoading(true);
            setShowLoader(true);
            const res = await myAxios("workLogs/phForm.php",  formData);
            if(!isMounted) return;
            setShowLoader(false);
            setShowLoading(false);
            if(!res) return;
            //---------------------------------------------------
            setPicData(JSON.parse(res.data.sign || "[]") || []);
            setPicData2(JSON.parse(res.data.sign2 || "[]") || []);
            const sketches = JSON.parse(res.data.sketches || "[]");
            if(Array.isArray(sketches)){
                sketches.forEach(e => {
                    if(e.sketchBgImg){
                        const img = new Image();
                        img.src = e.sketchBgImg[0];
                        e.sketchBgImg[0] = img; 
                    }
                })
                setSketches(sketches);
            }else{
                setSketches([]);
            }
            const form = res.data.form;
            setCurPotholingForm(
                {
                    ...form,
                    cancel: form.cancel || "No",
                    inDuct: form.inDuct || "No",
                    dryHole: form.dryHole || "No",

                }
            );
        }
        getData();
        return () => {
            isMounted = false;
            setShowLoader(false);
        }
    }, [])
    useEffect(() => {
        //canvas
        if(curPotholingForm.cancel === "Yes"){
            return;
        }
        const canvas = canvasRef.current;
        if(!canvas) return;
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        //start
        //text
        ctx.font = `${canvasFontSize}px Arial`;
        //ctx.fillText("unit: inch", canvas.width * 0.9, 30);
        //-------------------------------------------------------------------------------------------------------------------
        ctx.fillText("Pavement", text1X, text1Y);
        ctx.fillText("Thickness", text1X, text1Y + text1Spacing);
        ctx.fillText(`${curPotholingForm.pavementThickness} in`, input1Left, input1Top + 20);
        //-------------------------------------------------------------------------------------------------------------------
        ctx.fillText("Pothole Diameter", text2X - 15, text2Y);
        ctx.fillText(`${curPotholingForm.potholeDiameter} in`, input2Left + 30 - ctx.measureText(curPotholingForm.potholeDiameter).width / 2, input2Top + 20);
        //-------------------------------------------------------------------------------------------------------------------
        curPotholingForm.inDuct === "No"?
        ctx.fillText("Utility Diameter", text3X - 50, text3Y):
        ctx.fillText("Utility Duct Width", text3X - 60, text3Y)

        curPotholingForm.inDuct === "No"?
        ctx.fillText(curPotholingForm.dryHole === "No"?`${curPotholingForm.utilityDiameter} in`:"Dry Hole", input3Left, input3Top + 20):
        ctx.fillText(`${curPotholingForm.utilityDuctWidth} in`, input3Left, input3Top + 20)
        //-------------------------------------------------------------------------------------------------------------------
        ctx.fillText("Top Depth", text4X, text4Y);
        ctx.fillText(curPotholingForm.dryHole === "No"?`${curPotholingForm.topDepth} in`:"", input4Left, input4Top + 20);
        //pavement
        ctx.fillRect(originX, originY, ptWidth, PT);
        ctx.fillRect(originX + ptWidth + HoleSize, originY, ptWidth, PT);
        //line ---------------------
        ctx.beginPath();
        ctx.setLineDash([]);
        //pavement arrow
        canvas_arrow(ctx, originX + arrow1OffsetX, originY - arrowlength, originX  + arrow1OffsetX, originY);
        canvas_arrow(ctx, originX + arrow1OffsetX, originY + PT + arrowlength, originX  + arrow1OffsetX, originY + PT);
        //pothole size arrow
        canvas_arrow(ctx, originX + ptWidth - arrowlength, originY + arrow2OffsetY, originX + ptWidth, originY + arrow2OffsetY);
        canvas_arrow(ctx, originX + ptWidth + HoleSize + arrowlength, originY + arrow2OffsetY, originX + ptWidth + HoleSize, originY + arrow2OffsetY);
        //pipe size arrow
        canvas_arrow(ctx, originX + ptWidth + arrow3OffsetX, originY + Depth, originX + ptWidth + arrow3OffsetX, originY + Depth + PipeSize, true);
        //depth arrow
        canvas_arrow(ctx, originX + 2 * ptWidth + HoleSize + arrow4OffsetX, originY, originX + 2 * ptWidth + HoleSize + arrow4OffsetX, originY + Depth, true);
        //hole wall
        canvas_line(ctx, originX + ptWidth, originY, originX + ptWidth, originY + Depth + PipeSize);
        canvas_line(ctx, originX + ptWidth + HoleSize, originY, originX + ptWidth + HoleSize, originY + Depth + PipeSize);
        //hole bottom
        canvas_line(ctx, originX + ptWidth, originY + Depth + PipeSize, originX + ptWidth + HoleSize, originY + Depth + PipeSize);
        ctx.stroke();
        //-------------------------------------------------------------------------------------------------------------------
        ctx.beginPath();
        //pipe
        ctx.arc(originX + ptWidth + HoleSize / 2, originY + Depth + PipeSize / 2, PipeSize / 2, 0, 2 * Math.PI);
        ctx.stroke();
        //-------------------------------------------------------------------------------------------------------------------
        //invisible drawings
        ctx.beginPath();
        ctx.setLineDash([5, 5]);
        //pipe wall dash line
        //canvas_line(ctx, originX + ptWidth + ( HoleSize - PipeSize) / 2 , originY + Depth + PipeSize / 2, originX + ptWidth + ( HoleSize - PipeSize) / 2, originY);
        //canvas_line(ctx, originX + ptWidth + (HoleSize + PipeSize) / 2 , originY + Depth + PipeSize / 2, originX + ptWidth + (HoleSize + PipeSize) / 2, originY);
        ctx.stroke();
        //-------------------------------------------------------------------------------------------------------------------
        ctx.beginPath();
        ctx.setLineDash([5, 5]);
        //pavement dash line
        canvas_line(ctx, originX + arrow1OffsetX - annotationBarLength / 2, originY, originX + arrow1OffsetX + annotationBarLength / 2, originY);
        canvas_line(ctx, originX + arrow1OffsetX - annotationBarLength / 2, originY + PT, originX  + arrow1OffsetX + annotationBarLength / 2, originY + PT);
        //hole dash line
        canvas_line(ctx, originX + ptWidth, originY + arrow2OffsetY - annotationBarLength / 2, originX + ptWidth, originY + arrow2OffsetY + annotationBarLength / 2);
        canvas_line(ctx, originX + ptWidth + HoleSize, originY + arrow2OffsetY - annotationBarLength / 2, originX + ptWidth + HoleSize, originY + arrow2OffsetY + annotationBarLength / 2);
        //pipe dash line
        canvas_line(ctx, originX + ptWidth + arrow3OffsetX  - annotationBarLength / 2, originY + Depth, originX + ptWidth + HoleSize / 2, originY + Depth);
        canvas_line(ctx, originX + ptWidth + arrow3OffsetX  - annotationBarLength / 2, originY + Depth + PipeSize, originX + ptWidth + HoleSize / 2, originY + Depth + PipeSize);
        //depth dash line
        canvas_line(ctx, originX + 2 * ptWidth + HoleSize + arrow4OffsetX - annotationBarLength / 2, originY, originX + 2 * ptWidth + HoleSize + arrow4OffsetX + annotationBarLength / 2, originY);
        canvas_line(ctx, originX + ptWidth + HoleSize / 2, originY + Depth, originX + 2 * ptWidth + HoleSize + arrow4OffsetX + annotationBarLength / 2, originY + Depth);
        ctx.stroke();

    },[
        PT, Depth, HoleSize, PipeSize, arrow1OffsetX, arrow2OffsetY, arrow3OffsetX, text1Spacing, 
        text1X, text1Y, text2X, text2Y, text3X, text3Y, text4X, text4Y,
        input1Left, input1Top, input2Left, input2Top, input3Left, input3Top, input4Left, input4Top,
        curPotholingForm
    ])
    //-------------------------------------------------------------------------------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = {`POTHOLING FORM${curPotholingForm.potholeNumber?" " + curPotholingForm.potholeNumber:""}`}
            width = {800}
            maxWidth = {"100%"}
            handleFormSubmit = {handlePotholingFormSubmit}
            actionKey = "Submit"
            onSave = {handlePotholingFormSave}
        >
            {showLoading?
            <div className = "m-3 h5 text-center">Loading...</div>:
            <>
            <div className = "blk5 my-2" style = {{display: "flex"}}>
                <label className = "font-weight-bold required-field mr-3">Date</label>
                <input
                    type = "date"
                    min = "1900-01-01"
                    max = "2999-12-31"
                    required
                    name = "potholingFormDate"
                    className = "form-control"
                    value = {curPotholingForm.potholingFormDate ?? ""}
                    onChange = {e => {setCurPotholingForm({...curPotholingForm, potholingFormDate: e.currentTarget.value})}}
                />
            </div>
            <div className = "blk5 mb-2" style = {{display: "flex"}}>
                <label className = "font-weight-bold required-field mr-3">Pothole Number</label>
                <input
                    required
                    className = "form-control"
                    name = "potholeNumber" 
                    value = {curPotholingForm.potholeNumber || ""}
                    onChange = {e => {setCurPotholingForm({...curPotholingForm, potholeNumber: e.currentTarget.value})}}
                />
            </div>
            <div className = "mb-2" style = {{display: "flex", alignItems: "center"}}>
                <label className = "font-weight-bold required-field mr-3">Cancel</label>
                <label htmlFor = "CancelYes" className = "mr-2">Yes</label>
                <input
                    type = "radio"
                    required = {true}
                    id = "CancelYes"
                    name = "cancel"
                    checked = {curPotholingForm.cancel === "Yes"}
                    value = "Yes"
                    onChange = {e => {
                        setCurPotholingForm({
                            ...curPotholingForm, 
                            cancel: e.currentTarget.value
                        }); 
                    }}
                    className = "mr-3"
                    style = {{
                        width: 28, 
                        height: 28, 
                        verticalAlign: "middle", 
                        flexShrink: 0
                    }}
                />
                <label htmlFor = "CancelNo" className = "mr-2">No</label>
                <input
                    type = "radio"
                    required = {true}
                    id = "CancelNo"
                    name = "cancel"
                    checked = {curPotholingForm.cancel === "No"}
                    value = "No"
                    onChange = {e => {
                        setCurPotholingForm({
                            ...curPotholingForm, 
                            cancel: e.currentTarget.value
                        }); 
                    }}
                    className = "mr-3"
                    style = {{
                        width: 28, 
                        height: 28, 
                        verticalAlign: "middle", 
                        flexShrink: 0
                    }}
                />
            </div>
            {curPotholingForm.cancel === "No"?<>
            <div className = "blk5 mb-2" style = {{display: "flex", alignItems: "center"}}>
                <label className = "required-field font-weight-bold mr-3">Type of Surface</label>
                <select
                    className = "form-control"
                    required
                    name = "surface"
                    value = {curPotholingForm.surface || ""}
                    onChange = {e => {setCurPotholingForm({...curPotholingForm, surface: e.currentTarget.value})}}
                >
                    <option value = "">Select</option>
                    {surfaces.map(value => <option>{value}</option>)}
                </select>
            </div>
            <div className = "blk5 mb-2" style = {{display: "flex", alignItems: "center"}}>
                <label className = "required-field font-weight-bold mr-3">Soil Type</label>
                <select
                    className = "form-control"
                    required
                    name = "soil"
                    value = {curPotholingForm.soil || ""}
                    onChange = {e => {setCurPotholingForm({...curPotholingForm, soil: e.currentTarget.value})}}
                >
                    <option value = "">Select</option>
                    {soilTypes.map(value => <option>{value}</option>)}
                </select>
            </div>
            <div className = "blk5 mb-2" style = {{display: "flex", alignItems: "center"}}>
                <label className = "required-field font-weight-bold mr-3">Core Drill</label>
                <div>
                    <select
                        className = "form-control"
                        required
                        name = "coreDrill"
                        value = {curPotholingForm.coreDrill || ""}
                        onChange = {e => {setCurPotholingForm({...curPotholingForm, coreDrill: e.currentTarget.value})}}
                    >
                        <option value = "">Select</option>
                        {coreDrills.map(value => <option>{value}</option>)}
                    </select>
                </div>
            </div>
            <div className = "blk5 mb-2" style = {{display: "flex", alignItems: "center"}}>
                <label className = "required-field font-weight-bold mr-3">Utility Type</label>
                <select
                    className = "form-control mr-3"
                    required
                    name = "utility"
                    value = {curPotholingForm.utility || ""}
                    onChange = {e => {setCurPotholingForm({...curPotholingForm, utility: e.currentTarget.value})}}
                >
                    <option value = "">Select</option>
                    {utilityTypes.map(value => <option>{value}</option>)}
                </select>
                <span className = "text-info">Let us know if your choice is not included.</span>
            </div>
            <div className = "blk5 mb-2" style = {{display: "flex", alignItems: "center"}}>
                <label className = "required-field font-weight-bold mr-3">Utility Material</label>
                <input
                    className = "form-control"
                    required
                    name = "pipeMaterial"
                    value = {curPotholingForm.pipeMaterial || ""}
                    onChange = {e => {setCurPotholingForm({...curPotholingForm, pipeMaterial: e.currentTarget.value})}}
                />
            </div>
            <div className = "mb-2" style = {{display: "flex", alignItems: "center"}}>
                <label className = "required-field font-weight-bold mr-3">Dry Hole?</label>
                <label htmlFor = "dryHoleYes" className = "mr-2">Yes</label>
                <input
                    type = "radio"
                    required = {true}
                    id = "dryHoleYes"
                    name = "dryHole"
                    checked = {curPotholingForm.dryHole === "Yes"}
                    value = "Yes"
                    onChange = {e => {
                        setCurPotholingForm({
                            ...curPotholingForm, 
                            dryHole: e.currentTarget.value
                        });
                    }}
                    className = "mr-3"
                    style = {{
                        width: 28, 
                        height: 28, 
                        verticalAlign: "middle", 
                        flexShrink: 0
                    }}
                />
                <label htmlFor = "dryHoleNo" className = "mr-2">No</label>
                <input
                    type = "radio"
                    required = {true}
                    id = "dryHoleNo"
                    name = "dryHole"
                    checked = {curPotholingForm.dryHole === "No"}
                    value = "No"
                    onChange = {e => {
                        setCurPotholingForm({
                            ...curPotholingForm, 
                            dryHole: e.currentTarget.value
                        });
                    }}
                    className = "mr-3"
                    style = {{
                        width: 28, 
                        height: 28, 
                        verticalAlign: "middle", 
                        flexShrink: 0
                    }}
                />
            </div>
            <div className = "mb-2" style = {{display: "flex", alignItems: "center"}}>
                <div className = "required-field mr-2"><strong>Utility In Duct?</strong></div>
                <label htmlFor = "inDuctYes" className = "mr-2">Yes</label>
                <input
                    type = "radio"
                    required = {true}
                    id = "inDuctYes"
                    name = "inDuct"
                    checked = {curPotholingForm.inDuct === "Yes"}
                    value = "Yes"
                    onChange = {e => {
                        setCurPotholingForm({
                            ...curPotholingForm, 
                            inDuct: e.currentTarget.value
                        });
                    }}
                    className = "mr-3"
                    style = {{
                        width: 28, 
                        height: 28, 
                        verticalAlign: "middle", 
                        flexShrink: 0
                    }}
                />
                <label htmlFor = "inDuctNo" className = "mr-2">No</label>
                <input
                    type = "radio"
                    required = {true}
                    id = "inDuctNo"
                    name = "inDuct"
                    checked = {curPotholingForm.inDuct === "No"}
                    value = "No"
                    onChange = {e => {
                        setCurPotholingForm({
                            ...curPotholingForm, 
                            inDuct: e.currentTarget.value
                        });
                    }}
                    className = "mr-3"
                    style = {{
                        width: 28, 
                        height: 28, 
                        verticalAlign: "middle", 
                        flexShrink: 0
                    }}
                />
            </div>
            {curPotholingForm.dryHole === "No"?<>
            {curPotholingForm.inDuct === "No"?
            <div className = "blk5 mb-2" style = {{display: "flex", alignItems: "center"}}>
                <label className = "font-weight-bold mr-3">Utility Diameter</label>
                <div style = {{display: "flex", alignItems: "center"}}>
                    <input
                        type = "number"
                        step = "any"
                        className = "form-control mr-2"
                        name = "utilityDiameter"
                        value = {curPotholingForm.utilityDiameter || ""}
                        onChange = {e => {
                            setCurPotholingForm({...curPotholingForm, utilityDiameter: e.currentTarget.value}); 
                        }}
                    /> 
                    <label>inches</label>
                </div>
            </div>
            :
            <div className = "blk5 mb-2" style = {{display: "flex", alignItems: "center"}}>
                <label className = "font-weight-bold mr-3">Utility Duct Width</label>
                <div style = {{display: "flex", alignItems: "center"}}>
                    <input
                        type = "number"
                        step = "any"
                        name = "utilityDuctWidth"
                        value = {curPotholingForm.utilityDuctWidth || ""}
                        className = "form-control mr-2"
                        onChange = {e => {
                            setCurPotholingForm({...curPotholingForm, utilityDuctWidth: e.currentTarget.value}); 
                        }}
                    /> 
                    <label>inches</label>
                </div>
            </div>}
            </>:<></>}
            <div className = "blk5 mb-2" style = {{display: "flex", alignItems: "center"}}>
                <label className = "font-weight-bold mr-3">Pothole Diameter</label>
                <div style = {{display: "flex", alignItems: "center"}}>
                    <input
                        type = "number"
                        step = "any"
                        className = "form-control mr-2"
                        name = "potholeDiameter"
                        value = {curPotholingForm.potholeDiameter || ""}
                        onChange = {e => {
                            setCurPotholingForm({...curPotholingForm, potholeDiameter: e.currentTarget.value});
                        }}
                    />
                    <label>inches</label>
                </div>
            </div>
            <div className = "blk5 mb-2" style = {{display: "flex", alignItems: "center"}}>
                <label className = "font-weight-bold mr-3">Pavement Thickness</label>
                <div style = {{display: "flex", alignItems: "center"}}>
                    <input
                        type = "number"
                        step = "any"
                        className = "form-control mr-2"
                        name = "pavementThickness"
                        value = {curPotholingForm.pavementThickness || ""}
                        onChange = {e => {
                            setCurPotholingForm({...curPotholingForm, pavementThickness: e.currentTarget.value});
                        }}
                    />
                    <label>inches</label>
                </div>
            </div>
            {curPotholingForm.dryHole === "No"?
            <div className = "blk5 mb-2" style = {{display: "flex", alignItems: "center"}}>
                <label className = "font-weight-bold mr-3">Top Depth</label>
                <div style = {{display: "flex", alignItems: "center"}}>
                    <input
                        type = "number"
                        step = "any"
                        value = {curPotholingForm.topDepth || ""}
                        className = "form-control mr-2"
                        name = "topDepth"
                        onChange = {e => {
                            setCurPotholingForm({...curPotholingForm, topDepth: e.currentTarget.value});
                        }}
                    /> 
                    <label>inches</label>
                </div>
            </div>:<></>}
            <div className = "nodisplay">
                <div className = "mb-2 h5">
                    <u>Transverse View</u>
                </div>
                <div className = "h6 mb-2">(not to scale)</div>
                <div style = {{position:"relative"}}>
                    <canvas className = "mb-2 border" ref = {canvasRef} width = {canvasWidth} height = {canvasHeight}/>
                    {false?/*for graph scaling*/<>
                    <div><input
                        type = "number"
                        step = "any"
                        className = "nodisplay"
                        style = {{
                            position: "absolute", 
                            left: input1Left, 
                            top: input1Top, 
                            width: inputWidth, 
                            height: inputHeight, 
                            textAlign: "center"
                        }}
                        name = "OLDpavementThickness"
                        value = {pt || ""}
                        onChange = {e => {
                            if(e.currentTarget.value >= 0 && e.currentTarget.value <= 100){
                                setPt(e.currentTarget.value);
                            }
                        }}
                    /></div>
                    <div><input
                        type = "number"
                        step = "any"
                        className = "nodisplay"
                        style = {{
                            position: "absolute", 
                            left: input2Left, 
                            top: input2Top, 
                            width: inputWidth, 
                            height: inputHeight, 
                            textAlign: "center"
                        }}
                        name = "OLDpotholeSize"
                        value = {holeSize || ""}
                        onChange = {e => {
                            if(e.currentTarget.value >= 0 && e.currentTarget.value <= 150){
                                setHoleSize(e.currentTarget.value);
                            }
                        }}
                    /></div>
                    <div><input
                        type = "number"
                        step = "any"
                        className = "nodisplay"
                        style = {{
                            position: "absolute", 
                            left: input3Left, 
                            top: input3Top, 
                            width: inputWidth, 
                            height: inputHeight, 
                            textAlign: "center"
                        }}
                        name = "OLDpipeSize"
                        value = {pipeSize || ""}
                        onChange = {e => {
                            if(e.currentTarget.value >= 0 && e.currentTarget.value <= 150){
                                setPipeSize(e.currentTarget.value);
                            }
                        }}
                    /></div>
                    <div><input
                        type = "number"
                        step = "any"
                        className = "nodisplay"
                        style = {{
                            position: "absolute", 
                            left: input4Left, 
                            top: input4Top, 
                            width: inputWidth, 
                            height: inputHeight, 
                            textAlign: "center"
                        }}
                        name = "OLDdepth"
                        value = {depth || ""}
                        onChange = {e => {
                            if(e.currentTarget.value >= 0 && e.currentTarget.value < 65378.5){
                                setDepth(e.currentTarget.value);
                            }
                        }}
                    /></div>
                    </>:<></>}
                </div>
            </div>
            <div>
                <div className = "blk5 mb-2" style = {{display: "flex", alignItems: "center"}}>
                    <label className = "font-weight-bold mr-3">Swing Tie 1:</label>
                    <input
                        className = "form-control"
                        name = "swingTie1"
                        value = {curPotholingForm.swingTie1 || ""}
                        onChange = {e => {setCurPotholingForm({...curPotholingForm, swingTie1: e.currentTarget.value})}}
                    />
                </div>
                <div className = "blk5 mb-2" style = {{display: "flex", alignItems: "center"}}>
                    <label className = "font-weight-bold mr-3">Swing Tie 2:</label>
                    <input
                        className = "form-control"
                        name = "swingTie2"
                        value = {curPotholingForm.swingTie2 || ""}
                        onChange = {e => {setCurPotholingForm({...curPotholingForm, swingTie2: e.currentTarget.value})}}
                    />
                </div>
                <div className = "blk5 mb-2" style = {{display: "flex", alignItems: "center"}}>
                    <label className = "font-weight-bold mr-3">Swing Tie 3:</label>
                    <input
                        className = "form-control"
                        name = "swingTie3"
                        value = {curPotholingForm.swingTie3 || ""}
                        onChange = {e => {setCurPotholingForm({...curPotholingForm, swingTie3: e.currentTarget.value})}}
                    />
                </div>
            </div>

            </>:<></>}
            <div className = "blk5 mb-2" style = {{display: "flex", alignItems: "center"}}>
                <label className = "font-weight-bold mr-3">Notes:</label>
                <textarea
                    className = "form-control w-100"
                    name = "notes"
                    value = {curPotholingForm.notes || ""}
                    onChange = {e => {setCurPotholingForm({...curPotholingForm, notes: e.currentTarget.value})}}
                />
            </div>
            <Sketch 
                mainClassName = "mb-2"
                buttonClasName = "my-2"
                sketches = {sketches} 
                setSketches = {setSketches}
                limit = {6}
                showSketch = {showSketch}
                setShowSketch = {setShowSketch}
            />
            <div className = "border rounded p-2 mb-2">
                <div className = "blk5 mb-2" style = {{display: "flex", alignItems: "center"}}>
                    <label className = "required-field mr-3">Technician:</label>
                    <input
                        type = "text"
                        className = "form-control mr-3"
                        disabled
                        name = "inspector"
                        value = {adminLink?userName:user.userName}
                    />
                    <label className = "required-field mr-3">Date:</label>
                    <input
                        type = "text"
                        className = "form-control mr-3"
                        disabled
                        name = "formDate"
                        value = {(new MyDate()).s()}
                    />
                </div>
                <Esign
                    buttonClassName = "my-2"
                    picData = {picData}
                    setPicData = {setPicData}
                    id = {"a"}
                />
            </div>
            <div className = "border rounded p-2 mb-2">
                <div className = "blk5 mb-2" style = {{display: "flex", alignItems: "center"}}>
                    <label className = "required-field mr-2">Client:</label>
                    <input
                        type = "text"
                        className = "form-control"
                        disabled
                        name = "client"
                        value = {contactName}
                    />
                </div>
                <Esign
                    buttonClassName = "my-2"
                    picData = {picData2}
                    setPicData = {setPicData2}
                    id = {"b"}
                />
            </div>
            </>}
        </Modal>
    )    
}
